module.exports = __webpack_public_path__ + "img/caramel.62d6238e.png";